import FilesEmpty from './files-empty.vue'
import FilesTable from './files-table.vue'
import FilesDrop from './files-drop.vue'
import $files from 'stores/files'


import $global from 'stores/global'
import {FTYPES} from 'consts/ftypes'

const DEF_LIMIT = 20

const __default__ = {
  data() {
    return {
      initial_load: true,
      load_params: {skip: 0, limit: DEF_LIMIT, filter: ''},
      active: false,
      error: false,
      highlight: '',
    }
  },
  computed: {
    loading () {
      return $files.loading
    },
    store_loaded () {
      return $files.loaded
    },
    show_loading () {
      // store is loading for the first time
      return !$files.loaded && this.initial_load
    },
    show_refreshing () {
      // was loaded already and loading again
      return !$files.loaded && !this.initial_load
    },
    show_empty () {
      // loaded but still no files, checking total (not $files.length) because files can be filtered
      return $files.loaded && $files.total === 0
    },
  },
  async mounted() {
    if (!$global.fileUploadEnabled) {
      await $global.goToChats()
    }
    this.initial_load = true

    await this.loadItems({total: true})
    this.initial_load = false
  },
  beforeUnmount(){
    $files.watch.abort()
  },
  methods: {
    async loadItems({total = false, ...ev} = {}){
      this.load_params = {...this.load_params, ...ev}
      await $files.load({...this.load_params, total})
      this.highlight = ev.name || this.load_params.name || ''
    },
    async onUpload(files) {
      await $files.upload(files[0], {
        to_files: false,
        keep: true,
        resolve: result => {
          if ($files.files.find(file => file.id === result.id)) return
          this.loadItems({total: true})
        }
      })
    },
    dragover(event) {
      this.active = true
    },
    dragleave(event) {
      if (event.currentTarget.contains(event.relatedTarget)) return
      this.active = false
    },
    drop(event) {
      const files = Array.from(event.dataTransfer.items)
        .filter(item => item.kind === 'file')
        .map(item => item.getAsFile())
      if (files.length) this.onUpload(files)
      this.active = false
    },
    async onDelete(ids) {
      const tasks = ids.map(id => $files.delete(id))
      await Promise.all(tasks)
      const first_page = this.load_params.skip === 0
      const last_page = (this.load_params.skip + this.load_params.limit) >= $files.count
      if ($files.files.length === 0 && !first_page && last_page) {
        this.load_params.skip = this.load_params.skip - this.load_params.limit
      }
      await this.loadItems({total: true})
      if (!$files.count) this.$refs.table?.clearFilters()
    }
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'files',
  setup(__props, { expose: __expose }) {
  __expose();

const EXTS = FTYPES.document.exts.map(ext => ext.toUpperCase().slice(1))

const __returned__ = { DEF_LIMIT, EXTS, get $global() { return $global }, get FTYPES() { return FTYPES }, FilesEmpty, FilesTable, FilesDrop, get $files() { return $files } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})